import styled from 'foundations-theming/utils';
import { View } from 'foundations-components/components/View';
import { BREAKPOINTS } from 'foundations-components/transitional/components/Grid';
import ApiError from '../Errors/ApiError';
import RecommendationsContainer from '../../containers/RecommendationsContainer';
import useWootricSurvey from '../../hooks/useWootricSurvey';
import { academyPageFullWidth, useMediaQuery } from 'academy-common-lib/utils/Styling';
import HubspotPlaylistsSection from '../../features/hubspotPlaylists/components/HubspotPlaylistsSection';
import { HasGate } from '../../features/accounts/components/HasGate';
import { InProgressSection } from '../../features/userProgress';
import AnnouncementsSection from '../../features/announcements/components/AnnouncementsSection';
import { NavMarker } from 'react-rhumb';
import HomePageSection from './HomePageSection';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const InnerWrapper = styled.div.withConfig({
  displayName: "HomePageLayout__InnerWrapper",
  componentId: "sc-1jdvl1g-0"
})(["", " padding:", " ", ";overflow:hidden;@media (max-width:", "px){padding:", " ", ";}@media (max-width:", "px){padding:", " ", ";}"], academyPageFullWidth, ({
  theme
}) => theme.space['0'], ({
  theme
}) => theme.space['1100'], BREAKPOINTS.md, ({
  theme
}) => theme.space['0'], ({
  theme
}) => theme.space['600'], BREAKPOINTS.sm, ({
  theme
}) => theme.space['0'], ({
  theme
}) => theme.space['300']);
const HomePageLayoutLegacy = ({
  children,
  error,
  footerComponent
}) => {
  const {
    isMobile
  } = useMediaQuery();
  return /*#__PURE__*/_jsxs(View, {
    inlineSize: "100%",
    children: [error ?
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(InnerWrapper, {
      children: /*#__PURE__*/_jsx(ApiError, {
        error: error,
        marker404: "HOMEPAGE_API_404",
        markerDefault: "HOMEPAGE_API_ERROR",
        resetLink: "/"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(InnerWrapper, {
        children: /*#__PURE__*/_jsx(InProgressSection, {})
      }), /*#__PURE__*/_jsx(HasGate, {
        fallback: /*#__PURE__*/_jsx(NavMarker, {
          name: "HOMEPAGE_ANNOUNCEMENTS_LOADED"
        }),
        gate: "Academy:Announcements",
        children: /*#__PURE__*/_jsx(InnerWrapper, {
          children: /*#__PURE__*/_jsx(AnnouncementsSection, {})
        })
      }), /*#__PURE__*/_jsx(HubspotPlaylistsSection, {}), /*#__PURE__*/_jsx(InnerWrapper, {
        children: /*#__PURE__*/_jsx(View, {
          "data-test-id": "pre-catalog-cards-container",
          marginBlockEnd: isMobile ? '100' : '1100',
          children: /*#__PURE__*/_jsx(RecommendationsContainer, {})
        })
      }), children]
    }), !error && footerComponent]
  });
};
const HomePageLayout = ({
  children,
  error,
  footerComponent
}) => {
  const {
    isMobile
  } = useMediaQuery();
  useWootricSurvey('CES');
  useWootricSurvey('CSAT');
  return /*#__PURE__*/_jsx(HasGate, {
    fallback: /*#__PURE__*/_jsx(HomePageLayoutLegacy, {
      error: error,
      footerComponent: footerComponent,
      children: children
    }),
    gate: "Academy:UnifiedAcademy:Navigation",
    children: /*#__PURE__*/_jsx(View, {
      inlineSize: "100%",
      children: error ?
      /*#__PURE__*/
      // @bend-expect trellis-tokenized
      _jsx(HomePageSection, {
        children: /*#__PURE__*/_jsx(ApiError, {
          error: error,
          marker404: "HOMEPAGE_API_404",
          markerDefault: "HOMEPAGE_API_ERROR",
          resetLink: "/"
        })
      }) : /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(InProgressSection, {}), /*#__PURE__*/_jsxs(Flex, {
          flexDirection: "column",
          gap: isMobile ? '500' : '1000',
          paddingBlock: isMobile ? '500' : '1000',
          children: [/*#__PURE__*/_jsx(HasGate, {
            fallback: /*#__PURE__*/_jsx(NavMarker, {
              name: "HOMEPAGE_ANNOUNCEMENTS_LOADED"
            }),
            gate: "Academy:Announcements",
            children: /*#__PURE__*/_jsx(AnnouncementsSection, {})
          }), /*#__PURE__*/_jsx(HubspotPlaylistsSection, {}), /*#__PURE__*/_jsx(View, {
            "data-test-id": "pre-catalog-cards-container",
            children: /*#__PURE__*/_jsx(RecommendationsContainer, {})
          })]
        }), !error && footerComponent]
      })
    })
  });
};
export default HomePageLayout;